import React, {Component} from 'react';
import Breadcrumb from "../common/breadcrumb";
import { loadObject, AuthenticatedUser, stopTimer } from "../api";
import TagList from "../common/tagList"
import ReactHtmlParser from "react-html-parser";
import 'react-quill/dist/quill.snow.css';
import '../common/quillEditor/quilltable.css'

class LandingPager extends Component {
    constructor(props) {
        super(props);
        const { user } = AuthenticatedUser();
        const { match: { params } } = this.props;

        this.state = {
            loading: true,
            user: user,
            data: {},
            pid: params.pid
        }

    }

    loadLandingPage = (pid) => { 
        if (!pid) pid = this.state.pid;      
        if (pid) {
            loadObject('landingPage', pid).then(d2 => {
                if (d2 && d2.error) {
                    console.log(d2.error);
                } else {
                    this.setState({ pid: pid, data: d2.landingPage, viewable: true, loading: false});                    
                }
            });
        } else this.setState({ loading: false});
    };

    componentDidMount() {
        this.loadLandingPage();
    }

    componentDidUpdate(prevProps) {
        if(prevProps.match.params.pid !== this.props.match.params.pid) {
            this.loadLandingPage(this.props.match.params.pid);            
        }
    }

    render(){
        if (this.state.loading) { return null; }
        else {
            stopTimer();      
            const { data } = this.state;

            return (
                <div>
                <Breadcrumb title={data.title} />

                {/*Blog Details section*/}
                <section className="blog-detail-page section-b-space">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-12 blog-detail">
                                <img src={data.imageUrl ? data.imageUrl:''}  className="img-fluid w-100"  alt=""/>
                                <h3>{data.title}</h3>

                                <div className="row">
                                    <div className="col-sm-12 ql-editor">
                                        {ReactHtmlParser(data.content)}
                                    </div>
                                </div>
                            </div>
                        </div>
{/*                        
                        {viewable ||
                        <div className="row">
                            <div className="col-sm-12">
                                <NotViewablePitch pid={this.state.pid} />
                            </div>
                        </div>
                        }
*/}
                        <br /> 
                        <hr/>
                        <TagList tags={data.tags}/>
                        <hr/>
{/* LI
                        <div className="row section-b-space">
                            <div className="col-sm-12">
                                <Comments user={this.state.user} comments={data.comments} />
                            </div>
                        </div>
*/}
                    </div>
                </section>

            </div>
            )
        }
    }
}

export default LandingPager;